// Library imports
import axios from 'axios';
// import _ from 'lodash';
// Project imports
// import * as types from '../actionTypes';
import * as urls from '../urlTypes';

import { toastError } from '../../util/toastUtils';

export const _getAllAccountList = async () => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/accounts?all=true`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return {
        ...response.data,
        data: response.data.data,
      };
    }
    return false;
  } catch (error) {
    toastError('Api failed to get accounts list');
    return false;
  }
};

export const _executeReport = async request => {
  const url = `${urls.API_GATEWAY_URL}/api/data-enablement-service/exportActReport`;
  try {
    const response = await axios({
      url,
      method: 'post',
      data: request,
      withCredentials: true,
      responseType: 'json',
    });

    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      if (response.data.data.url) {
        return response.data.data.url;
      }
      toastError('Api failed to generate report');
      return false;
    }
    toastError('Api failed to generate report');
    return false;
  } catch (error) {
    toastError('Api failed to generate report');
    return false;
  }
};
